import React, {useState} from 'react';
import '../css/ProfilePage.css';
import Profile from '../assets/img/profile.png';
import {useAuth} from "../utils/auth.context";
import {changePassword} from "../services/apiService";
import Translate, {t} from "../components/Translate";
import {getCurrentUser} from "../services/authService";
import {toast} from "react-toastify";

const currentUser = getCurrentUser() ? getCurrentUser() : {language: 'en'};

const ProfilePage = () => {
    const {user} = useAuth();
    const {_username, role, isPublishModeActive} = user?.data ?? {};
    const [isChangingPassword, setIsChangingPassword] = useState(false);
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');

    const handleChangePassword = () => {
        changePassword(_username, newPassword, currentPassword)
            .then(result => {
                setError(result)
                setIsChangingPassword(false)
                toast.success(t(currentUser.language, 'success'), {position: "top-right", theme: "colored"});
            })
            .catch(() => {
                toast.error(t(currentUser.language, 'error'), {position: "top-right", theme: "colored"});
            });
    };

    return (
        <div className="profile-container">
            <div className="profile-card">
                <div className="profile-header">
                    <img className="profile-image" src={Profile} alt="Profile"/>
                </div>
                <div className="profile-body">
                    <h2 className="profile-name">
                        <Translate language={currentUser.language} text={'username'}/>: {_username}
                    </h2>
                    <p className="profile-title"><Translate language={currentUser.language} text={'role'}/>: {role}</p>
                    <p className="profile-title"><Translate language={currentUser.language} text={'publishMode'}/>: {isPublishModeActive ? t(currentUser.language, 'active') : t(currentUser.language, 'passive')}</p>
                    <div className="profile-socials">
                        <a href="#" className="social-icon">
                            <i className="fab fa-twitter"></i>
                        </a>
                        <a href="#" className="social-icon">
                            <i className="fab fa-linkedin-in"></i>
                        </a>
                        <a href="#" className="social-icon">
                            <i className="fab fa-github"></i>
                        </a>
                    </div>
                    <button
                        className="rbutton"
                        onClick={() => setIsChangingPassword(!isChangingPassword)}
                    >
                        {isChangingPassword ? t(currentUser.language, 'cancel') : t(currentUser.language, 'changePassword')}
                    </button>
                    <div className={`change-password-form ${isChangingPassword ? 'open' : 'closed'}`}>
                        {isChangingPassword && (
                            <>
                                <input
                                    type="password"
                                    placeholder={t(currentUser.language, 'currentPassword')}
                                    value={currentPassword}
                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                />
                                <input
                                    type="password"
                                    placeholder={t(currentUser.language, 'newPassword')}
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                />
                                <input
                                    type="password"
                                    placeholder={t(currentUser.language, 'confirmNewPassword')}
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                />
                                <button
                                    className="change-password-button"
                                    onClick={handleChangePassword}
                                >
                                    <Translate language={currentUser.language} text={'changePassword'}/>

                                </button>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfilePage;
